import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Filename-safe slug (accents stripped, non-alphanumerics collapsed to "-").
// Used for artifact PDF fallback names (§9.11, pdfFallbackName).
export function slugify(text, fallback = "valiosia") {
  const COMBINING = /[̀-ͯ]/g;
  const slug = (text || "")
    .normalize("NFD")
    .replace(COMBINING, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);
  return slug || fallback;
}
